import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useIsMobile } from "@/hooks/use-mobile";
import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import { RULE_TAB_GL, RULE_TAB_LEVEL, RULE_TABS } from "./consts";
import { useLocation, useParams } from "react-router-dom";

const useDistributionRuleConfiguration = () => {
  const {glId} = useParams();
  const isMobile = useIsMobile();
  const { communityData, currentFinanceYear } = useSelector(
    (state: RootState) => state.currentData
  );
  const communityName = communityData?.communityName || communityData?.name || "";
  const year = currentFinanceYear || new Date().getFullYear().toString();
  const location = useLocation();
  const fromTraceability = location?.pathname?.includes(routes.traceability);
  const [activeRuleTab, setActiveRuleTab] = useState(fromTraceability ? RULE_TAB_GL : RULE_TAB_LEVEL);
  
  const orgBreadcrumbData = useMemo(
    () => [
      {
        link: `/${routes.cam}/${routes.activityDashboard}`,
        name: `Activity Dashboard - ${communityName}`,
      },
      {
        link: "",
        name: <span className="text-primary">Allocation Rule</span>,
      },
    ],
    [communityName]
  );

  const traceabilityBreadcrumbData = useMemo(
    () => [
      {
        link: `/${routes.cam}/${routes.activityDashboard}`,
        name: `Activity Dashboard - ${communityName}`,
      },
      {
        link: `/${routes.cam}/${routes.activityDashboard}/${routes.traceability}`,
        name: `Traceability Report`,
      },
      {
        link: "",
        name: <span className="text-primary">GL - {glId}</span>,
      },
    ],
    [communityName]
  );

  const breadcrumbData = fromTraceability ? traceabilityBreadcrumbData : orgBreadcrumbData;
  const title = fromTraceability ? `Traceability Report - GL ${glId}` : "Allocation Rule" ; 

  const onRuleTabValueChange = (value: string) => {
    setActiveRuleTab(value);
  };

  return {
    activeRuleTab,
    breadcrumbData,
    isMobile,
    onRuleTabValueChange,
    ruleTabs: RULE_TABS,
    year,
    title
  };
};

export default useDistributionRuleConfiguration;
